/**
 * Configuration for the multi-variant ordering tab, keyed by the product's
 * `product_type`. Today only hair colour shades use it, but the type may grow
 * (e.g. sizes, finishes) — adding a new variant type later is one entry here
 * plus the matching i18n strings, with no component changes.
 */
export interface VariantTabConfig {
  /** i18n key for the tab label (e.g. "Shades"). */
  labelKey: string;
  /** Default tab label, used when the i18n key has no translation. */
  labelDefault: string;
  /** i18n key for the grid search field placeholder. */
  searchPlaceholderKey: string;
  /** Default search placeholder, used when the i18n key has no translation. */
  searchPlaceholderDefault: string;
}

// Add the i18n keys below to en.json / cs.json to localise; until then the
// `*Default` strings are used (via t()'s defaultValue), so it works out of the box.
export const VARIANT_TAB_CONFIG: Record<string, VariantTabConfig> = {
  color_with_variants: {
    labelKey: "variants.shades.tabLabel",
    labelDefault: "Shades",
    searchPlaceholderKey: "variants.shades.searchPlaceholder",
    searchPlaceholderDefault: "Search shades..."
  }
};

/** Returns the variant-tab config for a product type, or undefined. */
export function getVariantTabConfig(
  productType?: string | null
): VariantTabConfig | undefined {
  if (!productType) return undefined;
  return VARIANT_TAB_CONFIG[productType];
}

/** Whether a product type renders the multi-variant ordering grid. */
export function isMultiVariantProductType(
  productType?: string | null
): productType is string {
  return !!productType && productType in VARIANT_TAB_CONFIG;
}
